/**
 * Created by Administrator on 2018/5/15.
 */
// 获取可见窗口顶端与body对象最顶端的距离，考虑到浏览器版本兼容性问题，解析方式可能会不一样
const getScrollTop = () => {
  return document.documentElement.scrollTop || document.body.scrollTop
}
// 获取视口高度（网页可见区域高）浏览器可见内容高度,浏览器所有内容高度(考虑到浏览器版本兼容性问题，解析方式可能会不一样)
const getWinHeight = () => {
  return document.documentElement.clientHeight || document.body.clientHeight
}
// 获取文档总高度
const getScrollHeight = () => {
  let bodyScrollHeight = 0
  let documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  // 当页面内容超出浏览器可视窗口大小时，Html的高度包含body高度+margin+padding+border所以html高度可能会大于body高度
  return (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
}
// 是否滚动到底部
const isReachBottom = () => {
  const scrollTop = getScrollTop() // 获取滚动条的高度
  const winHeight = getWinHeight() // 一屏的高度
  const scrollHeight = getScrollHeight() // 获取文档总高度
  return scrollTop >= parseInt(scrollHeight) - winHeight
}
// 绑定方法
const bingListenScroll = (vm) => {
  window.addEventListener('scroll', function () {
    if (isReachBottom()) {
      vm.isReady = false
    }
  })
}
export default bingListenScroll



// WEBPACK FOOTER //
// ./src/common/js/isReachBottom.js